//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import asnTp from '@/components/page-temporary/asnTp';
export default {
  name: "asn-list",
  components: {asnTp},
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'送货管理',
        url:'api/asn-dt/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'物料编号/名称/单号/供应商',
          searchCondition:'key',
          rules:[{field: "material.matCode-materialName-asn.orderNo-purOrderDetail.purOrder.orderNo-asn.supplier.supplierName", option: "LIKE_ANYWHERE"}]
        },
        selectConfig:[
          {
            text: '工厂',
            type: 'search',
            condition: 'plant',
            searchCondition: {label: 'plantName', code: 'plantCode'},
            rules: [{field: "asn.plant.plantCode-asn.plant.plantName", option: "LIKE_ANYWHERE"}],
          },
          {
            text:'送货单状态',
            type:'selector',
            list:[{name:'全部',code:null},{name:'制单中',code:'DRAFT'},{name:'待发货',code:'TO_BE_DELIVERED'},{name:'已发货',code:'TO_BE_RECEIVED'}],
            rules:[{field: "asn.status",option: "EQ"}],
          },
          {
            text: '要货日期',
            type: 'date',
            isOld:true,
            rules:[{field: "deliveryDate",collectIndex: -1,option: "BTD"}],
          }
        ]
      },
      searchData:{},
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$refs.header.getlist();
    },
    goDetail(asn){
      this.$router.push("/asn/view/"+ asn.id);
    }
  },
  mounted(){
    this.init();
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/asn/asn-list.vue